import moment from "moment";

export const endTimeFormatter = (start, end) => {
  const endTime = moment(end).format("HH:mm");
  const endDate = moment(start)
    .add(1, "d")
    .format("YYYY-MM-DDT");
  return `${endDate}${endTime}`;
};

export const endTimeFormatterSingleDay = (start, end) => {
  const endTime = moment(end).format("HH:mm");
  const endDate = moment(start).format("YYYY-MM-DDT");
  return `${endDate}${endTime}`;
};
